<template>
    <div v-if="dialogActive">
    <v-dialog v-model="dialogActive"  persistent max-width="300px">
        <v-card fluid style="overflow: hidden;">
        <v-container fluid class="pa-0">
            <v-card-text class="card-text-container pt-4">
                <v-icon size="24" class="close-icon" @click="dialogHandler">mdi-close</v-icon>
                <div class="d-flex flex-column justify-space-between">
                    <p class="text-h6 py-0" :class="shortlistVal(dialogContent.avgScore*10)?.remarkClass">{{dialogContent?.interviewerRecommendation}} {{ Number(dialogContent.avgScore).toFixed(1) }}/10</p>
                    <p>{{ dialogContent?.interviewerEmail }}</p>
                <p class="text-disabled grey--text text-subtitle-1 remark-color pt-3 scrollable-container">
                {{dialogContent?.remark | strippedContent}}
                 </p>
        </div>
        </v-card-text>
        </v-container>
        </v-card>
    </v-dialog>
</div>  
</template>
<script>
export default {
    name: 'InterviewCommentBox',
    props: ["dialogActive", "dialogContent"],
    filters: {
        strippedContent: function(string) {
            return string?.replace(/<\/?[^>]+>/ig, " "); 
            },
            
    },
    methods: {
        dialogHandler(){
            this.$emit('dialogHandler')
        },
        shortlistVal(value) {
      if (value < 40) {
        return {
          text: 'Not Recommended',
          remarkClass: 'not-recommended-remark'
        };
      } else if (value >= 40 && value < 60) {
        return {
          text: 'Below Standard',
          remarkClass: 'below-standard-remark'
        };
      } else if (value >= 60 && value < 75) {
        return {
          text: 'Moderately Recommended',
          remarkClass: 'moderately-recommended-remark'
        };
      } else if (value >= 75 && value < 90) {
        return {
          text: 'Highly Recommended',
          remarkClass: 'highly-recommended-remark'
        };
      } else {
        return {
          text: 'Strongly Recommended',
          remarkClass: 'strongly-recommended-remark'
        };
      }
    },
    },

}
</script>
<style>
.card-text-container {
    position: relative;
}

.close-icon {
    position: absolute !important;
    top: 10px;
    left: 250px;
    cursor: pointer;
}
.remark-color{
    max-height: 12vh;
    overflow: auto;
    color: #666666;
}
.icon-aligner{
    margin-left: 90%; 
    margin-top: 2%;
}
.not-recommended-remark { color: #FF2600 !important; }
.below-standard-remark { color: #E39236 !important; }
.moderately-recommended-remark { 
  color: #97AD39 !important;
  min-width: 173px;
}
.highly-recommended-remark { color: #5F9C4A !important; }
.strongly-recommended-remark { color:#5F9C4A !important; }
.scrollable-container {
  overflow-y: scroll; /* Enable scrolling */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

/* Hide scrollbar for Chrome, Safari, and Opera */
.scrollable-container::-webkit-scrollbar {
  display: none;
}
</style>